module.exports = __webpack_public_path__ + "media/images/giftcard/enterprise-ce-a8cf1abf9de07f17f3c5eec1a4600e05.jpg";